import React from 'react';

const ContratCDD = ({
                        nomComplet,
                        cin,
                        adresse,
                        date,
                        dateDebut,
                        position,
                        salaire,
                    }) => (
    <div style={{padding: '20mm', fontFamily: 'Arial, sans-serif', fontSize: '12pt', lineHeight: '1.5'}}>
        <h2 style={{textAlign: 'center', textDecoration: 'underline'}}>CONTRAT DE TRAVAIL</h2>

        <p>
            La société <strong>GO&DEV DELIVERY CENTER</strong>, société à responsabilité limitée au capital
            <strong> 200 000,00 Dhs</strong>, inscrite au registre de commerce de Rabat sous le
            numéro <strong>179995</strong>,
            ayant son siège social à <strong>4 RUE ARROMANE SECTEUR 9 BLOC G HAY RIAD RABAT</strong>.
        </p>
        <p>D’une part ;</p>

        <p>
            Et <strong>{nomComplet || '..............................'}</strong>,
            demeurant au <strong>{adresse || '...........................................'}</strong>,
            titulaire de la CIN N° <strong>{cin || '............................'}</strong>.
        </p>
        <p>D’autre part ;</p>

        <p style={{textAlign: 'center', fontWeight: 'bold'}}>Conviennent ce qui suit :</p>

        <h4>Article 1 : Attribution</h4>
        <p>
            <strong>{nomComplet || '..................................'}</strong> assurera au sein de la société
            <strong> GO&DEV DELIVERY CENTER</strong> la fonction
            <strong> {position || '(stagiaire, employé,…)'} </strong>. En conséquence, il prendra toutes mesures
            nécessaires
            pour exécuter les tâches qui lui seront attribuées par le gérant de la société.
        </p>

        <h4>Article 2 : Durée</h4>
        <p>
            Le présent contrat est conclu à compter du <strong>{dateDebut || '…/…/……'}</strong> pour une période de 6
            mois (renouvelable une fois),
            période pendant laquelle, il pourra être résilié par le stagiaire/l’employeur uniquement après
            la fin de la période de stage, de même pour la société GO&DEV.
        </p>
        <p>
            Toutefois, celles des parties qui voudra mettre fin durant la période de stage, devra prévenir l’autre
            de son intention à cet égard. Un préavis d’une semaine est dans ce cas, à observer sauf à finaliser les
            travaux qui sont à la charge du salarié.
        </p>

        <div style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
            <h4 style={{ marginTop: '30px', marginBottom: '10px', fontWeight: 'bold' }}>
                Article 3 : SALAIRE
            </h4>
            <p>
                Pour la rémunération de son activité, <strong>le stagiaire/employé</strong> recevra une somme de
                <strong> {salaire ? `${salaire} Dhs net` : ' ................ Dhs net'}</strong> par mois,
                qui lui sera payée par virement à l’expiration de chaque période d’un mois.<br />
                Son salaire sera amené à l’évolution en fonction de l’importance des tâches assurées.
            </p>
        </div>


        <h4>Article 5 : JURIDICTION COMPETENTE</h4>
        <p>
            Tous les litiges nés à l’exécution du présent contrat seront portés devant les juridictions marocaines
            compétentes de Rabat.
        </p>

        <h4>Article 6 : Frais</h4>
        <p>
            Les frais des présentes seront supportés par l’entreprise <strong>GO&DEV DELIVERY CENTER</strong>.
        </p>

        <h4>Article 7 : Domicile pour l’exécution des présentes</h4>
        <p>
            Les parties du présent contrat déclarent élire domicile à <strong>4 RUE ARROMANE SECTEUR 9 BLOC G HAY RIAD
            RABAT</strong>.
        </p>

        <p style={{marginTop: '20px'}}>
            Fait à RABAT, le <strong>{date || '…/…/……'}</strong>.
        </p>

        <div
            style={{
                position: 'absolute',
                bottom:' -250mm',
                left: 0,
                right: 0,
                textAlign: 'center',
            }}
        >
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Signatures :</p>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', padding: '0 10mm' }}>
                <div style={{ textAlign: 'left' }}>
                    <strong>GO&DEV « SARL AU »</strong><br />
                    Représentée par<br />
                    <strong>M. RELLIER PASCAL GEIRGES EUGENE</strong>
                </div>

                <div style={{ textAlign: 'right' }}>
                    <strong>Le stagiaire / l’employé</strong>
                </div>
            </div>
        </div>

    </div>
);

export default ContratCDD;
